import { render, staticRenderFns } from "./ContractVersions.vue?vue&type=template&id=072d77e6&scoped=true"
import script from "./ContractVersions.vue?vue&type=script&lang=js"
export * from "./ContractVersions.vue?vue&type=script&lang=js"
import style0 from "./ContractVersions.vue?vue&type=style&index=0&id=072d77e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072d77e6",
  null
  
)

export default component.exports